module.exports = __webpack_public_path__ + "img/icon_storage_blue.05fe6a96.svg";